import React from 'react';

import VerticalTabs from '../tabs/VerticalTabs';
import FunctionalTableComponent from '../table/FunctionalTableComponent';
import SimpleDictionaryFormConfig from '../common/SimpleDictionaryFormConfig';
import columns from '../common/SimpleDictionaryTableConfig';

const DictionariesManagementComponent = ({ setLoader, dictionaries }) => {
  const tabsConfig = {
    defaultActiveKey: dictionaries[0].key || dictionaries[0].api,
    tabs: dictionaries.map((d) => {
      return {
        key: d.key || d.api,
        label: d.label,
        withHeader: false,
        content: (
          <FunctionalTableComponent
            title={d.tableLabel || d.label}
            creationTitle={d.creationLabel}
            creationFields={d.fields || SimpleDictionaryFormConfig}
            remove={true}
            columns={d.columns || columns}
            header={true}
            api={d.api}
            apiFunction={d.apiFunction}
            shadow={false}
            setLoader={setLoader}
            removable={d.removable}
            readOnly={d.readOnly}
            width={12}
            editWithId={d.editWithId}
            editable={d.editable}
            pagination={true}
            deleteModalTitle={d.deleteModalTitle}
            deleteModalDescription={d.deleteModalDescription}
            modalSize={d.modalSize}
            createApi={d.createApi}
            deleteApi={d.deleteApi}
          />
        ),
      };
    }),
  };
  return (
    <>
      <VerticalTabs config={tabsConfig} />
    </>
  );
};

export default DictionariesManagementComponent;
